import React from 'react'
import Header from '../header/newheader'
import Footer from '../footer/newfooter';
import { Link } from 'react-router-dom'
import { BASE } from '../api/api'
import Axios from 'axios'

import funding from '../assets/fundingpdf.pdf'
import grant from '../assets/grantpdf.pdf'
import research from '../assets/researchpdf.pdf'
import divison from '../assets/sss.jpeg';
import Collaborators from '../assets/Collaborators.pdf'
import strt from '../assets/funding.jpg'
import strt2 from '../assets/grants.jpg'
import st1 from '../assets/strategy1.jpeg'
import st2 from '../assets/strategy2.jpeg'
import ReactHtmlParser from 'react-html-parser';
import SideBar from '../sidebar/sidebar'
import TopBar from '../topbar/topbar'


class Report extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            report: ''
        }
    }
    //  printTest2() {
    //   printJS('http://devifdb-be.tridz.in/print/view/pdf/publications_view/page_1?view_args[]=43054,40409,40325')

    // }
    topFunction() {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }

    

    signout() {
        localStorage.removeItem('token');
        localStorage.removeItem('expirytime');
        localStorage.removeItem('expiryref');
        // window.location.href = '/'

    }
    componentDidMount(){
        this.topFunction()
    }

    refreshexp() {
        let s = new Date();
        s.setSeconds(s.getSeconds() + 1800);
        localStorage.setItem('expiryref', s)
    }


    checkexpiry() {
        if (localStorage.getItem('expiryref')) {
            let expref = Date.parse(localStorage.getItem('expiryref'))
            let s = new Date();
            if (s > expref) {
                this.signout()
            }
            else {
                this.refreshexp()
            }

        }
        else {
            this.signout()
        }
    }
    render() {
        return (
            <div className='biopage'>
                <Header />
                <div className='container'>
                    <div className="page-people strategy" >
                        <div className='top-contents'>
                            <div className="crumbs"><Link to='/'>Home</Link> / <Link to='/report'>Research Division</Link></div>
                            {/* <TopBar data={'data1'} /> */}
                        </div>
                        <div className="main-content listing">
                            <div className='rowed ongoing-text'>
                                <img src={st2} />
                                <div>
                                <a target='_blank' href={research}><h1 className="heading2">Research Strategic Report</h1></a>
                                    <p>
                                        This research strategic plan is our guiding document for Impactful Areas of Research Excellence for the next five years (2021-2025).
                                        From this strategic plan, further key sub-strategies and implementation plans will be developed.
                                        </p>
                                </div>
                            </div>
                            <div className='rowed ongoing-text'>
                                <img src={strt2} />
                                <div>
                                    
                                    <a target='_blank' href={grant}><h1 className="heading2">Research Clusters Grants-Policies and Procedures</h1></a>
                                    <p>
                                    The document contains a detailed outline of CIS Research clusters grants application policies, processes and requirements.
                                        </p>
                                </div>
                            </div>
                            <div className='rowed ongoing-text'>
                                <img src={strt} />
                                <div>
                                <a target='_blank' href={funding}><h1 className="heading2"> Research Funding Sources Directory</h1> </a>
                                    <p>
                                    A resource guide listing all funding opportunities for researchers including CIS Research Clusters grants, 
                                    HBKU Thematic Grants, various Qatar Foundation Research Fund (QNRF), local stakeholders partners, as well as overseas funding agencies.
                                        </p>
                                </div>
                            </div>
                            <div className='rowed ongoing-text'>
                                <img src={divison} />
                                <div>
                                <a target='_blank' href={Collaborators}> <h1 className="heading2">Research Collaborations and Partnerships</h1> </a>
                                    <p>
                                    CIS has signed collaborations and MOUs with several institutions which includes both public and private stakeholders in Qatar and several important International institutions. These collaboration identify potential areas of student exchange and visiting programs, 
                                    joint events, and most importantly to identifying mutual areas of multidisciplinary research.
                                        </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='construct-footer'>
                    <Footer />
                </div>
            </div>
        )
    }
}
export default Report;